// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"6514937a","225":"aad65481"}[chunkId] + ".chunk.js";
};